import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { AppOriginEnum } from '@enums/app-origin.enum';
import { UrlEnum } from '@enums/url.enum';
import { Observable } from 'rxjs';
import { AuthConfigLoaderService } from '../auth-config-loader/auth-config-loader.service';
import { LocalStorageService } from '../local-storage/local-storage.service';
import { UrlService } from '../url/url.service';

@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  constructor(
    @Inject(AuthConfigLoaderService) private _authConfigLoaderService: AuthConfigLoaderService,
    @Inject(HttpClient) private _http: HttpClient,
    @Inject(UrlService) private _urlService: UrlService,
    @Inject(LocalStorageService) private localStorageService: LocalStorageService
  ) {}

  private basePayload = {
    clientKey: this._authConfigLoaderService.getSessionClientId(),
    origin: AppOriginEnum.MyFF,
  };

  public sendFinalOrderAnalytics(orderId: string): Observable<any> {
    const url: string = `${this._urlService.urls[UrlEnum.SEND_FINAL_ORDER_ANALYTICS]}`;
    const headers = { Sessionid: this.localStorageService.getUserSessionToken() };
    const payload = {
      ...this.basePayload,
      orderId: orderId,
    };

    return this._http.post(url, payload, { headers });
  }

  public sendLoginAnalytics(): Observable<any> {
    const url: string = `${this._urlService.urls[UrlEnum.SEND_LOGIN_ANALYTICS]}`;
    const headers = { Sessionid: this.localStorageService.getUserSessionToken() };

    return this._http.post(url, this.basePayload, { headers });
  }
}
